import { IconButton, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import dayjs from 'dayjs';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';

const attributeData = [
    {
        attribute: "treated_date_start",
        name_th: "วันที่เริ่มกลุ่มผู้ป่วย",
        name_us: "Cluster Start Date"
    },
    {
        attribute: "treated_date_end",
        name_th: "วันที่สิ้นสุดกลุ่มผู้ป่วย",
        name_us: "Cluster End Date"
    },
    {
        attribute: "cluster_length_day",
        name_th: "ระยะเวลาของกลุ่มผู้ป่วย",
        unit_th: "วัน",
        name_us: "Cluster Length Date",
        unit_us: "Day"
    },
    {
        attribute: "npatients",
        name_th: "จำนวนผู้ป่วยในกลุ่ม",
        unit_th: "ราย",
        name_us: "Cases",
        unit_us: "head"
    }
]

function ClusterContent(props) {
    const { data } = props;
    const [dataShow, setDataShow] = useState({});
    const [dataList, setDataList] = useState([]);

    useEffect(() => {
        // console.log(data);
        if (data !== undefined) {
            if (data.features !== undefined) {
                if (data.features.length === 1) {
                    setDataShow(data.features[0].values_.attributes);
                } else {
                    setDataList(data.features);
                }
            } else {
                setDataShow(data.attributes);
            }
        }
    }, [data]);

    return (
        <>
            {
                Object.keys(dataShow).length !== 0 ?
                    <Grid container spacing={0}>
                        <Grid xs={dataList.length > 1 ? 10 : 12} sx={{
                            backgroundColor: 'rgb(62, 152, 211)'
                        }}>
                            <Typography variant="h5" className="mb-2 font-primary" sx={{
                                padding: 2,
                                paddingBottom: 0,
                                color: 'white'
                            }}>
                                {
                                    `ต.${dataShow.tambon_name}`
                                }
                            </Typography>
                        </Grid>
                        <Grid xs={dataList.length > 1 ? 2 : 0} sx={{
                            backgroundColor: 'rgb(62, 152, 211)'
                        }}>
                            <IconButton
                                sx={{
                                    color: 'white',
                                    marginTop: '13px'
                                }}
                                onClick={(event) => {
                                    setDataShow({});
                                }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </Grid>
                        <Grid xs={12} sx={{
                            backgroundColor: 'rgb(62, 152, 211)',
                            marginBottom: 2
                        }}>
                            <Typography variant="h6" className="mb-2 font-primary" sx={{
                                fontWeight: 'normal',
                                paddingLeft: 2,
                                paddingRight: 2,
                                color: 'white'
                            }}>
                                {
                                    `อ.${dataShow.amphur_name} จ.${dataShow.province_name}`
                                }
                            </Typography>
                        </Grid>
                        <Grid xs={12} sx={{
                            borderBottom: 'solid 1px rgba(0, 0, 0, 0.2)'
                        }}>
                            <Typography variant="subtitle1" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center'
                            }}>
                                {
                                    `รุ่นการระบาด`
                                }
                            </Typography>
                            <Typography variant="h6" className="font-primary" sx={{
                                color: 'black',
                                textAlign: 'center',
                                fontWeight: 'normal'
                            }}>
                                {dataShow.cluster_length}
                            </Typography>
                        </Grid>
                        {
                            attributeData.map((attribute, index) => {
                                if (attribute.unit_th !== undefined) {
                                    return (
                                        <React.Fragment key={index}>
                                            <Grid xs={7} sx={{
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    paddingLeft: 2
                                                }}>
                                                    {attribute.name_th}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={3} sx={{
                                                paddingRight: 2,
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    textAlign: 'right'
                                                }}>
                                                    {dataShow[attribute.attribute].toLocaleString()}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={2} sx={{
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary">
                                                    {attribute.unit_th}
                                                </Typography>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                } else {
                                    return (
                                        <React.Fragment key={index}>
                                            <Grid xs={6} sx={{
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    paddingLeft: 2
                                                }}>
                                                    {attribute.name_th}
                                                </Typography>
                                            </Grid>
                                            <Grid xs={6} sx={{
                                                paddingRight: 2,
                                                paddingTop: 1,
                                                paddingBottom: 1
                                            }}>
                                                <Typography variant='body1' className="font-primary" sx={{
                                                    textAlign: 'right'
                                                }}>
                                                    {dayjs(dataShow[attribute.attribute]).format("DD MMMM BBBB")}
                                                </Typography>
                                            </Grid>
                                        </React.Fragment>
                                    )
                                }
                            })
                        }
                    </Grid> :
                    <List sx={{ width: '100%' }}>
                        {
                            dataList.map((data, index) => {
                                return (
                                    <ListItemButton
                                        key={index}
                                        onClick={(event) => {
                                            setDataShow(data.values_.attributes)
                                        }}
                                        // disableGutters
                                    >
                                        <ListItemText
                                            sx={{
                                                width: 180,
                                            }}
                                            primary={`ต. ${data.values_.attributes.tambon_name}`}
                                            secondary={`อ.${data.values_.attributes.amphur_name} จ.${data.values_.attributes.province_name}`}
                                        />
                                        <ListItemText
                                            sx={(theme) => ({
                                                textAlign: 'center',
                                            })}
                                            primary={`รุ่นการระบาด`}
                                            secondary={`${data.values_.attributes.cluster_length}`}
                                        />
                                    </ListItemButton>
                                )
                            })
                        }
                    </List>
            }
        </>
    )
}

export default ClusterContent;
